import { barIdForSlot } from '@chordbaker/music-theory';
import { BarState, SlotState, RowState, SectionState } from '../types';
import { generateUniqueId } from './idUtils';

// Deep copies a single slot, regenerating the ID. Every other field (chord,
// custom text, lyrics, and any field added later) is kept as is.
export const deepCopySlot = (originalSlot: SlotState): SlotState => {
  return {
    ...originalSlot,
    id: generateUniqueId('slot'),
  };
};

// Deep copies a bar and its slots, regenerating all IDs (the bar's from its new first slot)
const deepCopyBar = (originalBar: BarState): BarState => {
  const slots = originalBar.slots.map(slot => deepCopySlot(slot));
  return { ...originalBar, id: slots.length > 0 ? barIdForSlot(slots[0].id) : generateUniqueId('bar'), slots };
};

// Deep copies a row and all its bars and slots, regenerating all IDs
export const deepCopyRow = (originalRow: RowState): RowState => {
  return {
    ...originalRow,
    id: generateUniqueId('row'),
    bars: originalRow.bars.map(bar => deepCopyBar(bar)),
    timeSignature: originalRow.timeSignature ?? null,
  };
};

// Deep copies a section, its rows, and all their slots, regenerating all IDs
export const deepCopySection = (originalSection: SectionState): SectionState => {
  const newSectionId = generateUniqueId('section');

  const newRows = originalSection.rows.map(row => deepCopyRow(row));

  return {
    ...originalSection,
    id: newSectionId,
    rows: newRows,
    repeat: originalSection.repeat ?? null,
    note: originalSection.note ?? null,
  };
};
